interface ValidationError {
  field: string;
  message: string;
}

interface ErrorDetails {
  errors: ValidationError[];
}

type ErrorCode =
  | 'VAT_INVALID'
  | 'INSUFFICIENT_STORAGE_SPACE'
  | 'FILE_TOO_LARGE'
  | 'UPLOAD_SIZE_MISMATCH'
  | 'DIRECT_BLOB_UPLOAD_UNAVAILABLE'
  | 'INVITED_EMAIL_TAKEN'
  | 'INVITATION_EXPIRED';

export class ServerError extends Error {
  public readonly statusCode: number;
  public readonly details?: ErrorDetails;
  public readonly errorCode?: ErrorCode;

  constructor(
    public readonly data: { message: string; statusCode: number; details?: ErrorDetails; errorCode?: ErrorCode },
  ) {
    super(data.message);
    this.statusCode = data.statusCode;
    this.details = data.details;
    this.errorCode = data.errorCode;
  }
}
